module.exports = __webpack_public_path__ + "static/media/divider.2d045c23.svg";